// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const eztvColors: ColorType = {
  ...colorPalette,
  primary: '#CB922A',
  secondary: '#CB922A',
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
}

export const darkTheme = {
  colors: eztvColors,
  background: {
    primary: '#111',
    secondary: '#262626',
    highlight: eztvColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: eztvColors.primaryGray,
    secondary: eztvColors.secondaryGray,
    disabled: eztvColors.grayText,
    link: eztvColors.secondaryGray,
    hint: eztvColors.white,
    highlight: eztvColors.secondary,
    gray: eztvColors.primaryGray,
    seeAll: eztvColors.secondaryGray,
    primaryContrast: eztvColors.white,
  },
  border: {
    primary: eztvColors.primaryGray,
    gray: eztvColors.secondaryGray,
  },
  filter: {
    primary: eztvColors.primaryGray,
    secondary: eztvColors.secondaryGray,
    disabled: eztvColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: eztvColors.dark,
    color: eztvColors.white,
    border: eztvColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: eztvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: eztvColors.dark,
        selected: eztvColors.dark,
        progress: rgba(eztvColors.primary, 0.3),
        past: rgba(eztvColors.primary, 0.3),
        pastSelected: eztvColors.dark,
        pastHover: eztvColors.dark,
        empty: '#555555',
        emptyProgress: rgba(eztvColors.primary, 0.1),
      },
      text: {
        empty: eztvColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #111 0%,${rgba('#111', 0.97)} 13.03%,${rgba('#111', 0.69)} 43.24%,${rgba(
          '#111',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #111 0%,${rgba('#111', 0.73)} 34.97%,${rgba('#111', 0)} 100%);`,
    },
  },
  card: {
    title: eztvColors.white,
    subTitle: eztvColors.secondaryGray,
    bg: eztvColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {
    signLogoSize: 119,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
